import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { Router} from '@angular/router';
import { TokenService } from '../../Services/token.service';
import { DataUserService } from '../../Services/data-user.service';
import { DataApiService } from '../../Services/data-api.service';
import {MatDialog,MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material';
import { ModificarPrecioComponent } from '../dialogs/modificar-precio/modificar-precio.component';
import { ActivarConveniosComponent } from '../dialogs/activar-convenios/activar-convenios.component';
import { DialogCrearCuentaSecundariaComponent } from '../dialogs/dialog-crear-cuenta-secundaria/dialog-crear-cuenta-secundaria.component';
import { DialogLiquidacionComponent } from '../dialogs/dialog-liquidacion/dialog-liquidacion.component';
import { CrearUsuariosMototizadosComponent } from '../dialogs/crear-usuarios-mototizados/crear-usuarios-mototizados.component';
import { VerUsuariosMototizadosComponent } from '../dialogs/ver-usuarios-mototizados/ver-usuarios-mototizados.component';
import { AbrirAsignacionDeUsuariosComponent } from '../dialogs/abrir-asignacion-de-usuarios/abrir-asignacion-de-usuarios.component';
import { DescargarReporteUsuarioComponent } from '../dialogs/descargar-reporte-usuario/descargar-reporte-usuario.component';
import { VerConstanciasDeCargoComponent } from '../dialogs/ver-constancias-de-cargo/ver-constancias-de-cargo.component';
import { VerPerfilComponent } from '../ver-perfil/ver-perfil.component';
import { VerUsuariosSecundariosComponent } from '../dialogs/ver-usuarios-secundarios/ver-usuarios-secundarios.component';
import { CodigoDescuentoComponent } from '../dialogs/codigo-descuento/codigo-descuento.component';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {
  public loggedIn :boolean;  

  private id = this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token")));  
  
  typeuser = localStorage.getItem("type"); 



  constructor(
    private Auth:AuthService,
    private router:Router,
    private Token : TokenService,
    private DataUser:DataUserService,
    private dataApi:DataApiService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {    
    this.Auth.authStatus.subscribe(value=>this.loggedIn = value);
    this.getListUser(this.id);    
    const data = this.getListUser(this.id);
  }  

  logout(event: MouseEvent){
    event.preventDefault();
    this.Token.remove();
    this.Auth.changeStatus(false);
    this.router.navigateByUrl('/login');    
  }
  userData:any=[];

  getListUser(id:number){
    this.dataApi.getUser(id).subscribe( (data)=>{
      this.userData= data;
    });    
  }

 
  envioNuevo(){       
    this.router.navigateByUrl('profile/pedido');      
  }

  verUsuarios(){
    this.router.navigateByUrl('profile/usuarios');  
  }
  
  envioNuevoAdmin(){
     this.router.navigateByUrl('profile/map-admin');    
  }
  modificarPreciosDialog(){    
    this.openDialog(ModificarPrecioComponent,"50%");
  }
  
  activarConvenios(){    
    this.openDialog(ActivarConveniosComponent,"80%");
  }

  abrirDialogCrearCuentaSecundaria(){  
    this.dialog.open(DialogCrearCuentaSecundariaComponent,{
      width:"60%",
      data:{nombre_comercial:this.userData.nombre_comercial,razon_social:this.userData.razon_social},
      disableClose: false,
      autoFocus:true
    }); 
  }

  verUsuariosSecundarios(){
    this.dialog.open(VerUsuariosSecundariosComponent,{
      width:"60%",
      data:{id_root:this.id},
      disableClose: false,
      autoFocus:true
    }); 
    
  }
  abrirDialogoLiquidacion(){
    this.openDialog(DialogLiquidacionComponent,"90%");
  }
  crearUsuariosMotorizados(){
    this.openDialog(CrearUsuariosMototizadosComponent,"70%")
  }
  verUsuariosMotorizados(){
    this.openDialog(VerUsuariosMototizadosComponent,"70%")
  }
  abrirAsignacionDeUsuarios(){
    this.openDialog(AbrirAsignacionDeUsuariosComponent,"90%");
  }
  verConstanciasDeCargo(){   
    this.dialog.open(VerConstanciasDeCargoComponent,{
      width:"320px",
      data:this.userData.email,
      disableClose: false,
      autoFocus:true
    }); 
  }

  descargarReporteUsuario(){ 
    this.dialog.open(DescargarReporteUsuarioComponent,{
      width:"300px",
      data:this.id,
      disableClose: false,
      autoFocus:true
    }); 
  }
  
  openDialog(component,width){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = width; 
    this.dialog.open(component,dialogConfig)
  }

  verPerfilPersona(){      
    this.dialog.open(VerPerfilComponent,{
      width:"280px",
      data:{row:this.userData,typeuser:this.typeuser},
      disableClose: false,
      autoFocus:true
    }); 
  }
  verPerfilCompany(){
    this.dialog.open(VerPerfilComponent,{
      width:"60%",
      data:{row:this.userData,typeuser:this.typeuser},
      disableClose: false,
      autoFocus:true
    }); 
  }

  escogerRegion(region){
    if(this.typeuser!="admin"){
      localStorage.setItem("page","profile");
      localStorage.setItem("region",region);      
    }
    location.reload()   
  }

  abrirCodigoDescuento(){
    this.dialog.open(CodigoDescuentoComponent,{
      width:"400px",    
      disableClose: false,
      autoFocus:true
    });
  }
  

  
}
